import { render, staticRenderFns } from "./SkillHeader.vue?vue&type=template&id=74afcb4e&scoped=true&"
import script from "./SkillHeader.vue?vue&type=script&lang=ts&"
export * from "./SkillHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SkillHeader.vue?vue&type=style&index=0&id=74afcb4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74afcb4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
